'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function setGlobalLockScrollActive(_ref) {
  var open = _ref.open,
      lockScroll = _ref.lockScroll;

  if (open && lockScroll) {
    return styled.css(["body{-webkit-overflow-scrolling:touch;overflow:hidden;touch-action:none;overscroll-behavior:none;}"]);
  }

  return '';
}

var GlobalLockScroll = styled.createGlobalStyle(_templateObject(), setGlobalLockScrollActive);
GlobalLockScroll.propTypes = {
  lockScroll: index.propTypes.bool.isRequired,
  open: index.propTypes.bool.isRequired
};
GlobalLockScroll.displayName = 'GlobalLockScroll';

function LockScroll(props) {
  return /*#__PURE__*/React__default['default'].createElement(GlobalLockScroll, props);
}

LockScroll.propTypes = {
  lockScroll: index.propTypes.bool.isRequired,
  open: index.propTypes.bool.isRequired
};

exports.default = LockScroll;
//# sourceMappingURL=LockScroll.js.map
